import State from '../core/State';
import initialState from '../initialState';
import { DateTime } from 'luxon';
import produce, { Draft } from 'immer';

export const setFromPeriod = (date: DateTime) =>
  produce((draft: Draft<State>) => {
    draft.liftReportChartSetting.period.from = date;
  });

export const setToPeriod = (date: DateTime) =>
  produce((draft: Draft<State>) => {
    draft.liftReportChartSetting.period.to = date;
  });

export const dispose = () =>
  produce((draft: Draft<State>) => {
    draft.liftReportChartSetting = initialState.liftReportChartSetting;
  });
